
export default {
  name: 'H7ComparisonTable',
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    showIntro: {
      type: Boolean,
      default: true,
    },
    powerfulLedData: {
      type: Array,
      default: () => [],
    },
    compactLedData: {
      type: Array,
      default: () => [],
    },
    categoryUrl: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
    }
  },

  methods: {
    formatErrorLevel(level) {
      if (level === null) {
        return this.$t(
          'pages.blogLedAccessoiresVehicules.comparatifMeilleuresAmpoulesLedH7.comparison.noAntiError'
        )
      }
      const stars = '✴'.repeat(level)
      return `${stars} ${this.$t(
        'pages.blogLedAccessoiresVehicules.comparatifMeilleuresAmpoulesLedH7.comparison.level'
      )} ${level}`
    },

    formatStars(errorLevel) {
      return errorLevel.replace(/✴/g, '<span class="badge-star">★</span>')
    },
  },
}
